import { GlEmptyState } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'FilterEmptyState',
    components: {
        GlEmptyState
    }
};
